$(document).ready(function () {
    let slidesToShow = $('.carousel-category');
    slidesToShow.slick(
        $('[data-config-carousel-plp]').data('config-carousel-plp')
    );
    slidesToShow.removeClass('d-none');
});